import { createClient } from "@supabase/supabase-js";

const FALLBACK_SUPABASE_URL = "https://ltigrvmyuzucaqemmcsq.supabase.co";
const FALLBACK_SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx0aWdydm15dXp1Y2FxZW1tY3NxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgwMjM5MDMsImV4cCI6MjA3MzU5OTkwM30.kynaCp9mN8UUNwlky4fT1zVLRiiLs5OF9yzvQLiujqs";

export const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL || FALLBACK_SUPABASE_URL;
export const SUPABASE_ANON_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY || FALLBACK_SUPABASE_ANON_KEY;

if (
  !process.env.REACT_APP_SUPABASE_URL ||
  !process.env.REACT_APP_SUPABASE_ANON_KEY
) {
  console.warn(
    "REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY missing in environment. Falling back to bundled credentials."
  );
}

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error(
    "Supabase configuration missing. Define REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY."
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
